<template lang="pug">
footer
  .content
    .flex.items-start.justify-between
      .col-8
        h3 CÔNG TY TNHH CÔNG NGHỆ MẠNG THÔNG TIN VIỆT NAM
        ul.list-reset
          li.flex.items-start
            label.item-label Địa chỉ:
            .item-content Số 11, Đoàn Văn Bơ, Phường 13, Quận 4, TP.HCM, Việt Nam.
          li.flex.items-start
            label.item-label Mã số doanh nghiệp:
            .item-content 0314505650
          li.flex.items-start
            label.item-label Ngày cấp:
            .item-content 10/07/2017
          li.flex.items-start
            label.item-label Nơi cấp:
            .item-content Sở Kế hoạch và Đầu tư Tp. Hồ Chí Minh

      .col-4
        h3 Liên hệ chúng tôi
        ul.list-reset
          li.flex.items-start
            label.item-label Email:
            .item-content contact@vngaynay.vn
          li.flex.items-start
            label.item-label Điện thoại:
            .item-content 02836362391
          li.flex.items-start
            label.item-label Zalo:
            .item-content 0932728536
          //- li.flex.items-start(style="font-size: 20px; margin-top: 10px; color: yellow;cursor: pointer;", @click="handleClick") Cơ hội nghề nghiệp
    .col-12
      p.small.my0 Giấy phép thiết lập trang thông tin điện tử tổng hợp trên mạng Số 44/GP – STTTT do Sở Thông tin và Truyền thông Thành phố Hồ Chí Minh cấp ngày 13/9/2017
      p.small.my0 Chịu trách nhiệm nội dung:  Lê Phạm Huyền Nhung
      p.small.my0 Đối tác:
        a(href='https://xworld.biz/vi-VN').xworld_link XWorld
</template>

<script>
export default{
  name: 'footer',
  methods: {
    handleClick() {
      this.$router.push('/want')
    }
  },
  data () {
    return {
    }
  }
}
</script>


<style lang="stylus" scoped>
@import '../assets/variables.styl'
footer
  padding 10px
  background-color $color-primary
  color white
  .content
    limit-width()
    .item-label
      display inline-block
      width 140px
    .item-content
      display inline-block
  .xworld_link {
    color: white
    text-decoration none
  }
</style>



// WEBPACK FOOTER //
// Footer.vue?753e1e3e